<template>
  <Breadcrumbs title="" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header" v-if="this.eventDetails.title">
            <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img :src="this.eventDetails.coverurl" alt="Image description" class="event-cover" />
              </figure>
            </div>
            <span v-if="this.eventDetails.is_participant_check==='N'">
            <div v-if="this.eventDetails.is_open_register === 'Y'" >
            <div v-if="this.can_create_order_participate_full && this.can_create_order_participate_full === 'N'" >
                <button disabled class="btn btn-lg full-button">
                  <vue-feather type="users" stroke-width="2"></vue-feather>
                  ขณะนี้มีผู้สมัครเต็มจำนวนแล้ว
                </button>
              </div>
              <div v-else>
                 <a :href="this.$route.params.event_id + '/register'" class="register-link">
                  <button class="btn btn-lg register-button">
                    <div class="button-content">
                      <vue-feather type="users" stroke-width="2" class="register-icon"></vue-feather>
                      <span class="register-text">{{this.currentLanguage ==='en'?'Join Event Now!':'สมัครเข้าร่วมกิจกรรม'}}</span>
                      <vue-feather type="arrow-right" stroke-width="2" class="arrow-icon"></vue-feather>
                    </div>
                    <div class="button-shine"></div>
                  </button>
                 </a>
              </div>
              
            </div>
            <div  v-if="this.eventDetails.is_open_register === 'N'" >
              <button v-if="this.eventDetails.is_event_end === 'Y'" disabled class="btn btn-lg disabled-button">
                <vue-feather type="x-circle" stroke-width="2"></vue-feather>
                <h5>{{this.currentLanguage ==='en'?'Registration Closed':'ปิดรับสมัคร'}}</h5>
              </button>
              <button v-if="this.eventDetails.is_event_end === 'N'" disabled class="btn btn-lg coming-soon-button">
                <vue-feather type="clock" stroke-width="2"></vue-feather>
                <div class="coming-soon-content">
                  <span>{{this.currentLanguage ==='en'?'Participant registration opens soon':'เปิดรับสมัคร'}}</span>
                  <small>{{ this.eventDetails.registration_start_txt_th }}</small>
                </div>
              </button>
            </div>

            
            <a style="margin-top: 4px;"
               :href="this.eventDetails.is_open_participate_check !== 'N' ? this.$route.params.event_id + '/check' : undefined"
               :style="this.eventDetails.is_open_participate_check === 'N' ? 'pointer-events:none' : ''"
               class="register-link">
                  <button class="btn btn-sm check-button" :disabled="this.eventDetails.is_open_participate_check === 'N'">
                    <div class="button-content">
                      <vue-feather type="search" size="16" class="register-icon"></vue-feather>
                      <span class="register-text">{{this.currentLanguage ==='en'?'Participant checking':'ตรวจสอบรายชื่อ'}}</span>
                    </div>
                  </button>
            </a>

            </span>
            <span v-else>
              <a style="margin-top: 4px;"
                 :href="this.eventDetails.is_open_participate_check !== 'N' ? this.$route.params.event_id + '/participant' : undefined"
                 :style="this.eventDetails.is_open_participate_check === 'N' ? 'pointer-events:none' : ''"
                 class="register-link">
                  <button class="btn btn-sm check-button" :disabled="this.eventDetails.is_open_participate_check === 'N'">
                    <div class="button-content">
                      <vue-feather type="search" size="16" class="register-icon"></vue-feather>
                      <span class="register-text">{{this.currentLanguage ==='en'?'Participant checking':'ตรวจสอบรายชื่อ'}}</span>
                    </div>
                  </button>
              </a>
            </span>
            <p>&nbsp;</p>
            <h3>{{ this.eventDetails.title }}</h3>
            <p>
              <b><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{this.currentLanguage ==='en'?'Event date':'วันที่จัดกิจกรรม'}}: {{
            this.eventDetails.event_date_text }} </b>
              <br />
              <b>&nbsp;<i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp; {{this.currentLanguage ==='en'?'At':'ณ'}}: {{ this.eventDetails.location }}
              </b>
              <br />

            </p>
            <div v-if="this.currentLanguage === 'th'" style="border: 1px;padding: 10px;" v-html="this.eventDetails.content" class="card"></div>
            <div v-if="this.currentLanguage === 'en'" style="border: 1px;padding: 10px;" v-html="this.eventDetails.content_en" class="card"></div>

            <hr>
            <div v-if="this.eventDetails.organizer_info && this.currentLanguage==='th'" v-html="this.eventDetails.organizer_info"></div>
            <div v-if="this.eventDetails.organizer_info_en && this.currentLanguage==='en'" v-html="this.eventDetails.organizer_info_en"></div>

          </div>

          <div class="card-header event-skeleton" v-if="!this.eventDetails.title">
            <div class="skeleton skeleton-cover mb-3"></div>
            <div class="skeleton skeleton-button mb-2"></div>
            <div class="skeleton skeleton-button skeleton-button-secondary mb-4"></div>
            <div class="skeleton skeleton-title mb-2"></div>
            <div class="skeleton skeleton-line mb-2"></div>
            <div class="skeleton skeleton-line skeleton-line-short mb-3"></div>
            <div class="skeleton skeleton-content"></div>
          </div>
        </div>
        <div class="col-xl-12" v-if="this.eventDetails.title">
        
          <div class="card" v-if="this.eventDetails.is_open_register === 'Y' || this.eventDetails.is_event_end === 'Y'">

          
        </div>
      </div>

      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import axios from "axios";
import { computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'


export default {
  setup() {
    const siteData = reactive({
      title: `ระบบรับสมัครงานวิ่ง ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว | RUNRACE.IN.TH`,
      description: `ระบบรับสมัครงานวิ่ง ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว ติดต่อเปิดงานง่าย ใช้เวลาเพียง 1 วัน.. | RUNRACE.IN.TH`,
      keywords: `ระบบรับสมัครงานวิ่ง, งานวิ่ง,runrace,สนามวิ่ง,วิ่งใหนดี`,
      image: process.env.VUE_APP_IMAGE_COVER,
    })

    useHead({
      // Can be static or computed this.eventDetails.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },{
          property: `og:title`,
          content: computed(() => siteData.title),
        },
        {
          property: `og:description`,
          content: computed(() => siteData.description),
        },
      ],

    })

    return { siteData};

  },

  data() {
    return {
      isFoundImage: "true",
      eventDetails: [],
      
      eventPackage: {},
      is_find_order: "N",
      is_start_find_order: "N",
      result_find_order: {},
      txt_search: "",
      s3_url: process.env.VUE_APP_AWS_S3_URL,
      currentLanguage: 'th',
      can_create_order_participate_full: null
    };
  },
  async mounted() {
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
    await this.getEventDetail(this.$route.params.event_id);

    this.can_create_order_participate_full = await this.fn_check_participate_limit()
    //this.siteData.image = _data.coverurl ;
    //this.siteData.title = _data.title +' '+this.siteData.title ;
    //this.siteData.description = _data.title +' วันที่ '+_data.event_date_text+' ณ.'+_data.province+' '+this.siteData.description ;

  },
  methods: {
    async fn_check_participate_limit() {
      const isFreePayment = (this.eventDetails.payment_method || "").toUpperCase() === "FREE";
      const apiPath = isFreePayment
        ? "/v1/order/check-participate-limit-free"
        : "/v1/order/check-participate-limit";

      const res = await axios.post(apiPath, {
        event_key: this.$route.params.event_id,
        language: "TH"
      });
      if (res.data.status === "success") {
        return res.data.can_create_order;
      }else{
        return "N"
      }
    },
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/initial/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data.body[0];
        if(this.eventDetails === undefined){
          router.push({ path: "/404" });
        }else{
          this.siteData.title = this.eventDetails.title +" "+ this.siteData.title
        }

        
      } else {
        router.push({ path: "/404" });
      }
    }
  },
};
</script>

<style scoped>
.block {
  display: block;
  width: 100%;
  border: none;
  background-color: #04AA6D;
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
}

.event-cover {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  padding: 0;
  border: 0;
  border-radius: 0.6em;
  box-shadow: 0 0.5rem 1.25rem rgb(0 0 0 / 35%);
}

/* Register Button Styling */
.register-link {
  text-decoration: none;
  display: block;
  width: 100%;
}

.check-button {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #5f9ee7 0%, #357abd 100%);
  color: white;
  font-weight: bold;
  font-size: 13px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(80, 150, 230, 0.3);
}


.register-button {
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
}

.register-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(74, 144, 226, 0.4);
  background: linear-gradient(135deg, #357abd 0%, #2a5f99 100%);
}

.register-button:active {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(74, 144, 226, 0.3);
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  z-index: 2;
}

.register-icon {
  animation: pulse 2s infinite;
}

.register-text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  letter-spacing: 0.5px;
}

.arrow-icon {
  transition: transform 0.3s ease;
}

.register-button:hover .arrow-icon {
  transform: translateX(5px);
  animation: bounceRight 0.6s ease infinite alternate;
}

.button-shine {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transform: rotate(45deg);
  transition: all 0.6s ease;
  opacity: 0;
}

.register-button:hover .button-shine {
  animation: shine 1.5s ease infinite;
  opacity: 1;
}

.event-skeleton {
  width: 100%;
}

.skeleton {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background-color: #e8edf4;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -150px;
  width: 150px;
  height: 100%;
  background: linear-gradient(90deg, rgba(232, 237, 244, 0) 0%, rgba(255, 255, 255, 0.88) 50%, rgba(232, 237, 244, 0) 100%);
  animation: skeletonShimmer 1.2s infinite;
}

.skeleton-cover {
  width: 100%;
  height: 320px;
}

.skeleton-button {
  width: 100%;
  height: 50px;
  border-radius: 10px;
}

.skeleton-button-secondary {
  height: 40px;
}

.skeleton-title {
  width: 58%;
  height: 34px;
}

.skeleton-line {
  width: 100%;
  height: 18px;
}

.skeleton-line-short {
  width: 45%;
}

.skeleton-content {
  width: 100%;
  height: 160px;
}

@keyframes skeletonShimmer {
  0% {
    left: -150px;
  }
  100% {
    left: 100%;
  }
}

/* Animations */
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes bounceRight {
  0% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(8px);
  }
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .register-button {
    height: 60px;
    font-size: 16px;
  }

  .skeleton-cover {
    height: 190px;
  }

  .skeleton-title {
    width: 85%;
  }

  .skeleton-content {
    height: 120px;
  }
  
  .button-content {
    gap: 8px;
  }
}

/* Loading State */
.register-button:disabled {
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.register-button:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Disabled/Full Button */
.full-button {
  width: 100%;
  height: 70px;
  border: none;
  border-radius: 15px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.2);
}

/* Disabled Button (Event Ended) */
.disabled-button {
  width: 100%;
  height: 70px;
  border: none;
  border-radius: 15px;
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 8px 25px rgba(107, 114, 128, 0.2);
}

/* Coming Soon Button */
.coming-soon-button {
  width: 100%;
  height: 70px;
  border: none;
  border-radius: 15px;
  background: linear-gradient(135deg, #9b9b9b 0%, #adadad 100%);
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.2);
}

.coming-soon-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.coming-soon-content small {
  font-size: 12px;
  opacity: 0.9;
  font-weight: normal;
}


</style>
